export const NEW_LOCATION_ID_PREFIX = 'new-location-';

export const isNewLocationId = (locationId: string): boolean => {
  return locationId.startsWith(NEW_LOCATION_ID_PREFIX);
};

export const getNewLocationIndex = (locationId: string): number => {
  return parseInt(locationId.split('-')[2], 10);
};
